<template>
    <div>
        <loading v-bind:dspin="!contentLoaded"></loading>
        <table class="w3-table w3-bordered flow-table patients-table" v-show="contentLoaded">
            <thead class="flow-blue-color">
            <th>{{ $t("room") }}</th>
            <th>{{ $t("consultationGroup") }}</th>
            <th>{{ $t("status") }}</th>
            <th>{{ $t("actions") }}</th>
            </thead>
            <tbody v-show="sortedRooms.length === 0">
            <tr>
                <td colspan="8" class="w3-center flow-blue-color">
                    <b class="font-size-1pt25em">{{$t("noSharedRooms")}}</b>
                </td>
            </tr>
            </tbody>
            <tbody v-show="sortedRooms.length !== 0">
            <tr v-for="eachRoom in sortedRooms"
                v-bind:id="eachRoom.room.id">
                <td class="primary">
                    <router-link :to="{name: 'room', params: {roomId: eachRoom.room.id}}">
                        <span v-show="eachRoom.room.name">{{eachRoom.room.name}}</span>
                    </router-link>
                </td>

                <td>
                    <span v-show="eachRoom.room.group">{{eachRoom.room.group.displayName}}</span>
                </td>

                <td>
                    <span v-if="eachRoom.room.enabled">{{$t('Active')}}</span>
                    <span v-else>{{$t('notActive')}}</span>
                </td>

                <td>
                    <span v-if="alteringRoomId !== eachRoom.room.id">
                            <i class="fa fa-times-circle cursor-pointer w3-xlarge w3-text-red w3-margin-left w3-ripple"
                               v-show="eachRoom.room.enabled"
                               :title="$t('disable')"
                               @click="disableRoom(eachRoom)"></i>

                            <i class="fa fa-check-circle cursor-pointer w3-xlarge w3-margin-left w3-ripple enable-button" v-show="!eachRoom.room.enabled"
                               :title="$t('enable')"
                               @click="enableRoom(eachRoom)"></i>
                    </span>
                    <span v-else>
                        <i class="fa fa-spinner w3-spin w3-xlarge w3-margin-left w3-opacity w3-disabled transform-animation  w3-text-black">
                        </i>
                    </span>

                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Loading from "../common/Loading";
    import {EventBus} from "../../main";
    import FlowSelect from "../../components/common/FlowSelect";

    let frc = Vue.prototype.$frc;

    export default {
        name: "SharedRooms",
        components: {Loading, FlowSelect},
        data: function(){
            return{
                contentLoaded: false,
                sharedRooms: [],
                wardId: undefined,
                alteringRoomId: undefined
            }
        },
        computed: {
            isNormal (){
                return Vue.isNormal(Vue.prototype.$currentUser.user.role);
            },
            sortedRooms() {
                if (!this.sharedRooms) {
                    return [];
                }

                var rooms = this.sharedRooms;
                rooms.sort(function(a, b) {
                    if (!a.room || !b.room) {
                        return -1;
                    }

                    return a.room.displayName.localeCompare(b.room.displayName);
                });

                return rooms;
            }
        },
        mounted() {
            if (this.isNormal) {
                this.wardId = Vue.getNormalUserWardId();
            } else {
                this.wardId = Vue.prototype.$currentWard.id;
            }

            if (!this.wardId) {
                Vue.notifyError({
                    title: this.$t("WARD_NOT_FOUND")
                });

                return;
            }

            this.getSharedRooms();

            EventBus.$on("wardUpdated", this.getRoomOnWardUpdate);
        },
        beforeDestroy() {
            EventBus.$off("wardUpdated", this.getRoomOnWardUpdate);
        },
        methods: {
            getRoomOnWardUpdate() {
                this.wardId = Vue.prototype.$currentWard.id;
                this.getSharedRooms();
            },
            getSharedRooms() {
                var app = this;

                frc.getConsultationRoomsInWard(app.wardId, true).then(function (res) {
                    app.sharedRooms = res.data;
                    app.contentLoaded = true;
                    app.alteringRoomId = undefined;
                }).catch(function (ex) {
                    console.log(ex);
                });
            },
            enableRoom(eachRoom) {
                var app = this;
                app.alteringRoomId = eachRoom.room.id;

                frc.enableSharedRoomInWard(this.wardId, eachRoom.room.id).then(function (res) {
                    app.changeAndNotify("successfullyEnabledRoom");
                }).catch(function (ex) {
                    console.log(ex);
                });
            },
            disableRoom (eachRoom) {
                var app = this;
                app.alteringRoomId = eachRoom.room.id;

                frc.disableSharedRoomInWard(app.wardId, eachRoom.room.id).then(function (res) {
                    app.changeAndNotify("successfullyDisabledRoom");
                }).catch(function (ex) {
                    console.log(ex);
                });

            },
            changeAndNotify(message) {
                this.getSharedRooms();
                Vue.notifySuccess({title: this.$t(message)});
            }

        }
    }
</script>